import React from "react";
//Importar íconos de Material UI.
import { InsertDriveFile } from '@mui/icons-material/';

// PreviewByFilteType: Componente que renderiza la vista principal de los 
// archivos multimedia según el tipo de archivo seleccionado.

const PreviewByFileType = ({ fileType, filesSelected, fileSelected }) => {

    return (
        <>
            {/* Filtrar el array filesSelected para obtener el archivo seleccionado */}
            {filesSelected.filter(file => file.name === fileSelected).map(selectedFile => (
                <div className="container-img-preview" key={selectedFile.name} >

                    {fileType === "image" &&
                        <img src={URL.createObjectURL(selectedFile)} alt="Vista previa del archivo seleccionado"
                            style={{ maxWidth: '100%', maxHeight: '100%' }} />}

                    {/**--------------Si el archivo es un audio------------ */}
                    {fileType === "audio" &&
                        <audio controls src={URL.createObjectURL(selectedFile)} className="audio-preview" />}

                    {/**--------------Si el archivo es un audio------------ */}
                    {fileType === "document" &&
                        <InsertDriveFile sx={{ fontSize: "150px", color: "grey" }} />}
                </div>
            ))}

        </>
    )
};

export default PreviewByFileType;